import { IDirection, ITableCell, ITypography } from '@sanlam-glacier/app-common/components';
import { ReactNode } from 'react';

export type Reg28TableHeaderConfig<T = unknown> = (
  | {
      label: string;
      renderCellContent?: never;
    }
  | {
      renderCellContent: () => ReactNode;
      label?: never;
    }
) & {
  key?: keyof T | 'actions';
  allowSorting?: boolean;
  align?: 'left' | 'right';
  className?: string;
  direction?: IDirection;
};

export type TableHeaderProps<T> = {
  headers: Reg28TableHeaderConfig<T>[];
  handleSort?: (
    property: Reg28TableHeaderConfig<T>['key'] | string,
    direction: IDirection | undefined
  ) => void;
  align?: ITableCell['align'];
  tableHeaderClassName?: string;
  disabled?: boolean;
  actionHeaderKey?: string;
  hoverable?: boolean;
  sticky?: boolean;
  textAlign?: ITypography['align'];
};

export interface Regulation28TableHeadings {
  clientName: string;
  clientId: string;
  productType: string;
  totalDaysNonCompliant: number;
  exposureBreaches: string[];
}

export enum Regulation28HeaderKeys {
  clientName = 'clientName',
  clientId = 'clientId',
  productType = 'productType',
  totalDaysNonCompliant = 'totalDaysNonCompliant'
}
